/**
 * P3-16: Clear Jobs 按钮——清空所有职业分配。
 *
 * 旧实现要点（js/village.js:4909-4924）：
 * - 名称/描述：i18n `village.btn.job.clear` / `village.btn.job.clear.desc`；
 * - 点击：noConfirm 时直接 game.village.clearJobs(true)，否则确认框；
 * - 恒显示。
 */
import { useCallback, useMemo } from "react";
import { getGame } from "../../bridge/GameBridge";
import { t } from "../../bridge/i18n";
import { GameButton } from "../../components/GameButton";
import type { TooltipContentProvider } from "../../components/Tooltip/TooltipProvider";

function makeDescTooltip(description: string): TooltipContentProvider {
  return () => description;
}

export function ClearJobsBtn() {
  const description = t("village.btn.job.clear.desc");
  const onClick = useCallback(() => {
    const game = getGame();
    if (!game) {
      return;
    }
    if (game.opts.noConfirm) {
      game.village.clearJobs(true);
      return;
    }
    game.ui.confirm("", t("village.tab.clear.job.confirmation.msg"), () => {
      game.village.clearJobs(true);
    });
  }, []);
  const getTooltip = useMemo(() => makeDescTooltip(description), [description]);

  return (
    <GameButton
      name={t("village.btn.job.clear")}
      description={description}
      getTooltip={getTooltip}
      onClick={onClick}
    />
  );
}
